const HOST_API_ROUTE = `${process.env.REACT_APP_CHAT_API_ROUTE}`;
const HOST_WRITER_ROUTE = `${process.env.REACT_APP_WRITER_API_ROUTE}`;

const CHAT_API_ROUTE = `${HOST_API_ROUTE}/chat`;
const OPERATOR_API_ROUTE = `${HOST_API_ROUTE}/operator`;
const SETTING_API_ROUTE = `${HOST_API_ROUTE}/setting`;
const REPORT_API_ROUTE = `${HOST_API_ROUTE}/report`;
const ACCOUNT_API_ROUTE = `${HOST_WRITER_ROUTE}/account`;

export const GET_MENU_DIALOG_STATS_API_ROUTE = `${CHAT_API_ROUTE}/get-menu-dialog-stats`;
export const GET_BOTS_API_ROUTE = `${OPERATOR_API_ROUTE}/get-all-bots`;
export const GET_SETTING_BY_ID_API_ROUTE = `${SETTING_API_ROUTE}/get-setting-by-id?settingId=`;

export const GET_REPORT_BY_NAME_API_ROUTE = `${REPORT_API_ROUTE}/get-report-by-name`;
export const SAVE_REPORT_BY_NAME_API_ROUTE = `${REPORT_API_ROUTE}/save-report-by-name`;
export const SAVE_REPORT_BY_NAME_EXCEL_API_ROUTE = `${REPORT_API_ROUTE}/save-xlsx-report-by-name`;

export const SET_GRAFANA_COOKIE = `${ACCOUNT_API_ROUTE}/set-grafana-cookie`;